import React from 'react'
import { Container, ContainerInterno, Texto } from './Styled'

export default function CondicaoExclusiva () {

	return (
		<Container>
			<ContainerInterno>
				<Texto>ESSA CONDIÇÃO EXCLUSIVA PARA ALUNO ACABA DIA 15/07</Texto>
			</ContainerInterno>
		</Container>
	)
}
